export default __webpack_public_path__ + "static/media/phishing-indentify1.99342288.png";